// @flow
import * as React from 'react'
import Link from 'next/link'
import classnames from 'classnames'

import { usePillStyles } from './styles'

type PillProps = {
  size?: 'small' | 'medium' | 'large',
  color?: 'green' | 'gray' | 'red' | 'orange',
  href?: string,
  onClick?: (e: SyntheticEvent<HTMLElement>) => void,
  children: React.Node
}

const Pill = ({ size = 'medium', color = 'green', href, children, onClick, ...props }: PillProps) => {
  const classes = usePillStyles()

  const Badge = (
    <span
      className={classnames(classes.pillWrapper, size, color, {
        clickable: typeof href === 'string' || typeof onClick === 'function'
      })}
      {...props}
    >
      {children}
    </span>
  )
  return href ? <Link href={href}>{Badge}</Link> : Badge
}

export default Pill
